module.exports = __webpack_public_path__ + "img/Talk Graphic 3.28b6b74b.jpg";